export default __webpack_public_path__ + "static/media/slider-nexx-3.c0521f7e.jpg";